// const CryptoJS = require('crypto-js');
import moment from 'moment-timezone'

// generateVerification creates a random string for including in the OAuth2
// request, which is then validated in the response.
// let generateVerification = function () {
//   var verification = ''
//   var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
//   for (var i = 0; i < 32; i++) {
//     verification += possible.charAt(Math.floor(Math.random() * possible.length))
//   }
//   return verification
// }

// let generateCodeVerifier = function(length) {
//     var text = "";
//     var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
//     for (var i = 0; i < length; i++) {
//         text += possible.charAt(Math.floor(Math.random() * possible.length));
//     }
//     return text;
// }
// let generateCodeChallenge = function(code_verifier) {
//     return base64URL(CryptoJS.SHA256(code_verifier))
// }
// let base64URL = function base64URL(string) {
//     return string.toString(CryptoJS.enc.Base64).replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_')
// }
// var now = moment();

var tips = {
    source: "Traffic source, e.g. organic, facebook, propellerads, etc.",
    campaign: "Name of your advertising campaign as set in traffic source. Empty for organic traffic.",
    geo: "2 letter country code, determined by user's ip adress.",
    landing: "Name of your landing pages(popunders, banners). Usefull for AB tests.",
    siteid: "Publishers Zoneids.",
    category: "Categories of publisher's zones.",
    locale: "Locale code.",
    device: "Device type - iPhone, iPad..",
    device_name: "Name of device - iPhone_Xs, iPad mini..",
    os: "An operating system of device - iOS, Android.. ",
    os_ver: "Version of operating system.",
    isp: "Internet Service Provider (Carrier).",
    bundle_id: "App identificator in store.",
    bundle_ver: "Bundle verison.",
    ab_group: "Name of your test group, example: 'subscribe' vs 'start free & subscribe'.",
    ab_test: "Name of your test, example: 'subscribe_button'.",
    broker: "delete?",
    is_sandbox: "delete",
    product_id: "id of product in appstoreconnect.",
    is_bot: "if user was marked as bot.",
    browser: "Browser name - Safari, Chrome..",
    cost: "How much single event from cost_model costs.",
    cost_model: "Click, Install, Subscription..",
    partner: "Single partner can use multiple sources.",
    install: "Install event.",
    subscription: "Subscription event, includes subscriptions with trials and without.",
    revenue: "Gross revenue, e.g. before Apple's fee(30%-15%).",
    land: "Impression event, when user sees advertisement.",
    click: "When user clicks advertisement.",
    activation: "When subscribed user succesfully converts to paying user.",
    pay: "Fired when user pays.",
    return: "Refund event.",
    change: "Anomality.",
    expense: "How much you've spend buying this traffic.",
    trial: "Trial event.",
    postback: "Postback.",
};

export default {
    maxDate() {
        return moment().add(1, "days").format('YYYY-MM-DD');
    },
    dateRanges() {
        return {
            "Today": [
                new Date(moment().startOf('day').format("YYYY-MM-DDTHH:mm:ss")),
                new Date(moment().endOf('day').subtract(299, "seconds").format("YYYY-MM-DDTHH:mm:ss"))
            ],
            "Yesterday": [
                new Date(moment().subtract(1, "days").startOf('day').format("YYYY-MM-DDTHH:mm:ss")),
                new Date(moment().endOf('day').subtract(1, "days").subtract(299, "seconds").format("YYYY-MM-DDTHH:mm:ss"))
            ],
            "7 days": [
                new Date(moment().startOf('day').subtract(7, "days").format("YYYY-MM-DDTHH:mm:ssZ")),
                new Date(moment().endOf('day').subtract(299, "seconds").format("YYYY-MM-DDTHH:mm:ss"))
            ],
            "This week": [
                new Date(moment().startOf("isoWeek").format("YYYY-MM-DDTHH:mm:ss")),
                new Date(moment().endOf('day').subtract(299, "seconds").format("YYYY-MM-DDTHH:mm:ss"))
            ],
            "This month": [
                new Date(moment().startOf("month").format("YYYY-MM-DDTHH:mm:ss")),
                new Date(moment().endOf('day').subtract(299, "seconds").format("YYYY-MM-DDTHH:mm:ss"))
            ],
            "Last month": [
                new Date(moment().subtract(1, "month").startOf("month").format("YYYY-MM-DDTHH:mm:ss")),
                new Date(moment().subtract(1, "month").endOf("month").subtract(299, "seconds").format("YYYY-MM-DDTHH:mm:ss"))
            ],
            "This year": [
                new Date(moment().startOf("year").format("YYYY-MM-DDTHH:mm:ss")),
                new Date(moment().endOf('day').subtract(299, "seconds").format("YYYY-MM-DDTHH:mm:ss"))
            ]
        }
    },
    // returns difference in days
    SubDates(start, end) {
        return moment(end).diff(moment(start), 'days')
    },
    Normalize(arr, toAdd) {
        var normalized = []
        for (var i = 0; i < arr.length; i++) {
            normalized.push({
                name: arr[i],
                isPresent: false,
                toAdd: false,
                toRemove: false,
                tip: tips[arr[i]],
                rows: []
            })
            if (toAdd.indexOf(normalized[i].name) != -1) {
                normalized[i].toAdd = true
            }
        }

        return normalized
    },
    RoundNumber(number, decimals) {
        var newnumber = new Number(number + '').toFixed(parseInt(decimals));
        return parseFloat(newnumber);
    },
    StylesForEventOverview(eventName) {
        var color = 'black';
        var fontWeight = 'normal';
        switch (eventName) {
            case "revenue":
                color = '#85bb65'
                fontWeight = 'bold'
                break;
            case "expense":
                color = '#f29eab'
                fontWeight = 'bold'
                break;
            case "install":
                color = '#FC9401'
                break;
            case "trial":
                color = '#4CAF50'
                break;
            case "activation":
                color = '#2C9AE0'
                break;
            case "subscription":
                color = '#9B51E0'
                break;
            case "pay":
                color = '#76daff'
                break;
            case "return":
                color = '#c15959'
                break;
            case "change":
                color = '#A8592F'
                break;
            case "land":
                color = '#673187'
                break;
            case "click":
                color = '#ABA96F'
                break;
            case "postback":
                color = 'black'
                break;
            default:
                color = 'black';
        }

        return {
            color: color,
            fontWeight: fontWeight,
        }
    },
    StylesForEventSelectRemoving(eventName) {
        var color = 'black';
        var border = '1px solid black'
        var fontWeight = 'normal';
        switch (eventName) {
            case "revenue":
                border = '1px solid #85bb65'
                color = '#85bb65'
                fontWeight = 'bold'
                break;
            case "expense":
                border = '1px solid #f29eab'
                color = '#f29eab'
                fontWeight = 'bold'
                break;
            case "install":
                border = '1px solid #FC9401'
                color = '#FC9401'
                break;
            case "trial":
                border = '1px solid #4CAF50'
                color = '#4CAF50'
                break;
            case "subscription":
                border = '1px solid #9B51E0'
                color = '#9B51E0'
                break;
            case "activation":
                border = '1px solid #2C9AE0'
                color = '#2C9AE0'
                break;
            case "pay":
                border = '1px solid #76daff'
                color = '#76daff'
                break;
            case "return":
                border = '1px solid #c15959'
                color = '#c15959'
                break;
            case "change":
                border = '1px solid #A8592F'
                color = '#A8592F'
                break;
            case "land":
                border = '1px solid #673187'
                color = '#673187'
                break;
            case "click":
                border = '1px solid #ABA96F'
                color = '#ABA96F'
                break;
            case "postback":
                border = '1px solid black'
                color = 'black'
                break;
            default:
                border = '1px solid #black'
                color = 'black';
        }
        return {
            border: border,
            color: color,
            fontWeight: fontWeight,
        }
    },
    StylesForEventSelectPresent(eventName) {
        var background = 'transparent';
        var color = 'white';
        var fontWeight = 'normal';
        switch (eventName) {
            case "revenue":
                background = '#85bb65'
                fontWeight = 'bold'
                break;
            case "expense":
                background = '#f29eab'
                fontWeight = 'bold'
                break;
            case "install":
                background = '#FC9401'
                break;
            case "trial":
                background = '#4CAF50'
                break;
            case "subscription":
                background = '#9B51E0'
                break;
            case "activation":
                background = '#2C9AE0'
                break;
            case "pay":
                background = '#76daff'
                break;
            case "return":
                background = '#c15959'
                break;
            case "change":
                background = '#A8592F'
                break;
            case "land":
                background = '#673187'
                break;
            case "click":
                background = '#ABA96F'
                break;
            case "postback":
                background = 'black'
                break;
            default:
                color = 'black';
                background = 'transparent';
        }

        return {
            color: color,
            background: background,
            fontWeight: fontWeight,
        }
    }
}
